import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Button, Dropdown } from '@robinpowered/ui-kit';
import { FilterButton, FilterButtonContent } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faListUl,
} from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { useTranslation } from 'react-i18next';
import { GlobalSearchEntityType } from 'generated/graphql';

interface CategoryFilterProps {
  selectedCategory: GlobalSearchEntityType | null;
  onChange: (category: GlobalSearchEntityType | null) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  selectedCategory,
  onChange,
}) => {
  const { t } = useTranslation('globalNavigation', {
    keyPrefix: 'searchOverlay',
  });
  const [open, setOpen] = useState(false);

  const options: { value: GlobalSearchEntityType; label: string }[] = [
    { value: GlobalSearchEntityType.User, label: t('categoryFilter.people') },
    { value: GlobalSearchEntityType.Space, label: t('categoryFilter.spaces') },
    { value: GlobalSearchEntityType.Desk, label: t('categoryFilter.desks') },
  ];

  const selectedLabel = options.find(
    (option) => option.value === selectedCategory
  )?.label;

  return (
    <Dropdown
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      popupRender={() => (
        <FilterPanel role="group" aria-label={t('categoryFilter.groupLabel')}>
          {options.map((option) => {
            const isSelected = option.value === selectedCategory;
            return (
              <CategoryOption
                key={option.value}
                type="text"
                aria-pressed={isSelected}
                onClick={() => {
                  onChange(isSelected ? null : option.value);
                  setOpen(false);
                }}
              >
                {option.label}
              </CategoryOption>
            );
          })}
        </FilterPanel>
      )}
    >
      <FilterButton type="text">
        <FilterButtonContent>
          <FontAwesomeIcon icon={faListUl} />
          <span>
            {selectedLabel
              ? t('categoryFilter.triggerSelected', { category: selectedLabel })
              : t('category')}
          </span>
          <FontAwesomeIcon icon={faChevronDown} />
        </FilterButtonContent>
      </FilterButton>
    </Dropdown>
  );
};

const FilterPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  padding: 8px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

const CategoryOption = styled(Button)`
  justify-content: flex-start;
  width: 100%;
  min-height: 36px;
  text-align: left;

  &[aria-pressed='true'] {
    background: #f5f5f5;
    font-weight: 600;
  }
`;
